import React from 'react';
import PropTypes from 'prop-types';

import MainMenu from '../MainMenu';
import InteractivePopup from '../InteractivePopup';
import Icon from '../Icon';
import PageCaption from '../SiteHeader/page-caption';
import './styles.css';

class Nav extends React.Component {
  static propTypes = {
    idPrefix: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    idPrefix: 'main-nav',
  };

  state = { isOpen: false };

  handleOpen = () => {
    this.setState({ isOpen: true });
  };

  keyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      this.setState({ isOpen: true });
    }
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { idPrefix } = this.props;
    return (
      <InteractivePopup
        trigger={(
          /* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
          <a
            aria-haspopup="true"
            name="mainmenu"
            role="link"
            styleName="headerText"
            tabIndex={0}
            onKeyDown={this.keyDown}
            onClick={this.handleOpen}
          >
            <PageCaption />
            <Icon name="sort" size="tiny" styleName="sortIcon" />
          </a>
        )}
        basic
        flowing
        hoverable
        wide="very"
        position="bottom left"
        styleName="menuPopup"
        open={this.state.isOpen}
        onClose={this.handleClose}
      >
        <MainMenu idPrefix={idPrefix} onMenuSelect={this.handleClose} />
        <div styleName="spacer" role="separator" className="hidden-mobile" />
      </InteractivePopup>
    );
  }
}

export default Nav;
